/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormState, FormStateBuilder, MaskedTypes } from '@gh/common-shared';
import { DialogInput, NotificationService, WaitingService } from '@gh/core-ui';
import { AuthNumberBusinessService } from '../../resources/auth-number-business.service';
import { AuthNumber, createDummyAuthRequest } from '../../resources/auth-number.model';

export type AuthNumberGenerationConfig = Record<string, never>;

@Component({
  standalone: false,
  selector: 'gh-auth-number-generation-dialog',
  templateUrl: 'auth-number-generation-dialog.component.html',
  styleUrls: ['auth-number-generation-dialog.component.scss'],
})
export class AuthNumberGenerationDialogComponent implements DialogInput<AuthNumberGenerationConfig>, OnInit {
  input: AuthNumberGenerationConfig;
  form: FormState<AuthNumber>;
  request: AuthNumber = createDummyAuthRequest();

  constructor(
    private formStateBuilder: FormStateBuilder,
    private business: AuthNumberBusinessService,
    private waitings: WaitingService,
    private notifications: NotificationService,
    public dialogRef: MatDialogRef<AuthNumberGenerationDialogComponent>) {

  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: createDummyAuthRequest(),
      children: {
        sourceNumber: {
          required: true,
          type: MaskedTypes.SourceNumber,
        },
        authNumber: void 0,
      },
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.business.generate(this.form.submitValue).pipe(
      this.waitings.operator())
      .subscribe(
        (request) => this.form.setValue(request),
        this.notifications.processAll,
      );
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
